import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../../utils/pageTransitions";
import { get_supplier_reports } from "../../../../redux/actions/adminActions";
import { connect } from "react-redux";

function Reports({ accessToken, getReports, supplier_reports, selected }) {
  const [loading, setLoading] = useState(true);
  const [reports, setReports] = useState(supplier_reports);

  useEffect(() => {
    getReports(accessToken, selected, () => setLoading(false));
  }, [selected]);

  useEffect(() => {
    setReports(supplier_reports);
  }, [supplier_reports]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8">
            <div className="row">
              <div className="col-md-4 mt-3">
                <div className="hasRadius bgGreen center stats__card">
                  <div className="">
                    <p className="sectionText--small textIsGreen mb-1">
                      Total Earnings
                    </p>
                    <h2 className="sectionText--big textIsGreen textIsBold">
                      ₦{reports?.balance}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3">
                <div className="hasBorder hasRadius center stats__card">
                  <div className="">
                    <p className="sectionText--small textIsGray mb-1">
                      Total Orders
                    </p>
                    <h2 className="sectionText--big textIsBold">
                      {reports?.total_orders}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3">
                <div className="hasBorder hasRadius center stats__card">
                  <div className="">
                    <p className="sectionText--small textIsGray mb-1">
                      Accepted Orders
                    </p>
                    <h2 className="sectionText--big  textIsBold">
                      {reports?.accepted_orders}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3">
                <div className="hasBorder hasRadius center stats__card">
                  <div className="">
                    <p className="sectionText--small textIsGray mb-0">
                      Declined Orders
                    </p>
                    <h2 className="sectionText--big textIsBold">
                      {reports?.declined_orders}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3">
                <div className="hasBorder hasRadius center stats__card">
                  <div className="">
                    <p className="sectionText--small textIsGray mb-0">
                      Completed Orders
                    </p>
                    <h2 className="sectionText--big textIsBold">
                      {reports?.completed_orders}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-3">
                <div className="hasBorder hasRadius center stats__card">
                  <div className="">
                    <p className="sectionText--small textIsGray mb-0">
                      Total Payouts
                    </p>
                    <h2 className="sectionText--big  textIsBold">
                      {reports?.total_payout}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4"></div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  supplier_reports: state.admin.supplier_reports,
});

const mapDispatchToProps = (dispatch) => ({
  getReports: (token, status, success) =>
    dispatch(get_supplier_reports(token, status, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
